import * as React from 'react'

import { observer } from 'mobx-react'

import { LocationType } from '~/client/graph'
import {
  iconCatalogFor,
  IconPicker,
  IconPickerTrigger,
} from '~/client/src/shared/components/IconPicker'
import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import {
  getLocationKind,
  isLocationResourceType,
} from '~/client/src/shared/resources/domain/locationKind'

import MapViewItemsSetupStore from '../../stores/MapViewItemsSetup.store'

interface IProps {
  item: MapViewItemBase
  store: MapViewItemsSetupStore
}

@observer
export default class IconSelector extends React.Component<IProps> {
  public render() {
    const { iconName, dataObject } = this.props.item
    const isEquipment = dataObject?.type === LocationType.OffloadingEquipment

    if (!isEquipment && !isLocationResourceType(dataObject?.type)) {
      return null
    }
    return (
      <IconPicker
        value={iconName}
        onChange={this.onIconChange}
        catalog={iconCatalogFor(isEquipment)}
        kind={getLocationKind(dataObject)}
      >
        <IconPickerTrigger value={iconName} className="tw:w-auto" />
      </IconPicker>
    )
  }

  private onIconChange = (iconName: string) => {
    const { item, store } = this.props
    store.deselectMapViewItemDrawnPart()
    item.updateIcon(iconName as MapViewLocationIcon)
    store.addCurrentStateToHistory()
  }
}
